function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M6.838 2.185l3 3-6.515 6.516-2.675.295a.563.563 0 01-.621-.62l.297-2.678 6.514-6.513zm4.856-.446L10.285.329a1.126 1.126 0 00-1.592 0L7.368 1.656l3 3 1.326-1.325c.44-.44.44-1.152 0-1.591z",
  id: "edit_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "edit_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#edit_svg__a"
})), React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#edit_svg__a"
}), React.createElement("g", {
  mask: "url(#edit_svg__b)",
  fill: "#FDFDFD"
}, React.createElement("path", {
  d: "M-64-14.436H72v40H-64z"
})));

var SvgEdit = function SvgEdit(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12
  }, props), _ref, _ref2);
};

export default SvgEdit;